import { getEnvVariable } from './runtime-env';

export const API_BASE_URL = `https://${getEnvVariable('REACT_APP_API_DOMAIN') ?? ''}`;
